import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../../shared/_utils/services/base-service';
import { SpinnerService } from './spinner.service';
import { VacationDetail } from '../entities/vacation-detail';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

@Injectable()
export class VacationDetailService extends BaseService {

    uri = '/api/vacationDetail/';

    constructor(injector: Injector, spinnerService: SpinnerService) {
        super(injector);
       //console.log('Instance VacationDetailService');
      }

  buildSentence(entity?: VacationDetail, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      if (entity.vacationBody && entity.vacationBody.vacationHead.id) {
        query = query.concat(
          `vacationBody.vacationHead.id${QueryOperator.Equal}${entity.vacationBody.vacationHead.id}${QueryOperator.Split}`
        );
      }
     //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  search(entity?: VacationDetail, event?: LazyLoadEvent): Observable<ResponsePageable<VacationDetail>> {
   //console.log('ENTRA A BUSCAR DETAIL1');
    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event);
   //console.log('ENTRA A BUSCAR DETAIL2');
    return this.httpClient.get<ResponsePageable<VacationDetail>>(url, { params: httpParams })
       .pipe(
         tap(response => {
         //console.log('response de VacationDetail - Check Here');
         //console.log(response);
          return response;
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/vacation-detail.service.ts